var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"px-4 py-1.5 text-gray-700 bg-white border border-gray-300 rounded-lg",class:{
      'text-red-11 bg-red-9 border-red-11': _vm.isFleetApp
    },attrs:{"type":"button"},on:{"click":_vm.onFleetApp}},[_vm._v(" Fleet App ")])])}
var staticRenderFns = []

export { render, staticRenderFns }